import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';
import { convertToRS, convertToRSWithTwoDec } from 'core/js/FormUtils';


export default function MlmcreditInfo({mlmcreditObj}){
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white' }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={2}><FieldView2 label="Level"  value={ mlmcreditObj.creditlevel!==null && mlmcreditObj.creditlevel!==undefined?mlmcreditObj.creditlevel:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={3}><FieldView2 label="Credit %"  value={ mlmcreditObj.creditpercentage +'%'}/></Grid>
      
        <Grid item lg={4} xs={3}><FieldView2 label="Credit Value"  value={ convertToRSWithTwoDec(mlmcreditObj.creditvalue)}/></Grid>
        <Grid item lg={4} xs={3}><FieldView2 label="Order Value"  value={convertToRSWithTwoDec(mlmcreditObj.ordervalue)}/></Grid>
        </Grid>
      </Grid>
      </Box>
    )
}